import { render, staticRenderFns } from "./TransferContract2.vue?vue&type=template&id=c27e6ad4&scoped=true&"
import script from "./TransferContract2.vue?vue&type=script&lang=js&"
export * from "./TransferContract2.vue?vue&type=script&lang=js&"
import style0 from "./TransferContract2.vue?vue&type=style&index=0&id=c27e6ad4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27e6ad4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
